// based on https://github.sc-corp.net/Snapchat/snapchat/blob/master/
// libs/pikachu-common/src/main/java/snapchat/pikachu/common/utils/InsightsDimensionMappings.java#L152
export const interestsFullNameMap: Record<string, string> = {
    SLC_1: "adventure seekers",
    SLC_2: "arts & culture mavens",
    SLC_3: "automotive enthusiasts",
    SLC_4: "beachgoers & surfers",
    SLC_5: "beauty mavens",
    SLC_6: "bookworms & avid readers",
    SLC_7: "clubbers & party people",
    SLC_8: "collegiates",
    SLC_9: "comics & animation fans",
    SLC_10: "do-it-yourselfers",
    SLC_11: "fashion & style gurus",
    SLC_12: "film & tv fans",
    SLC_13: "action & thriller genre fans",
    SLC_14: "comedy fans",
    SLC_15: "cordcutters",
    SLC_16: "drama genre fans",
    SLC_17: "family genre fans",
    SLC_18: "horror genre fans",
    SLC_19: "movie theater goers",
    SLC_20: "reality tv fans",
    SLC_21: "romance & rom-com fans",
    SLC_22: "sci-fi & fantasy fans",
    SLC_23: "superhero film fans",
    SLC_24: "fitness enthusiasts",
    SLC_25: "cycling enthusiasts",
    SLC_26: "running enthusiasts",
    SLC_27: "yoga enthusiasts",
    SLC_28: "foodies",
    SLC_29: "candy & sweets lovers",
    SLC_30: "cooking enthusiasts",
    SLC_31: "fast food junkies",
    SLC_32: "vegans & organic foodies",
    SLC_33: "gamers",
    SLC_34: "casual & mobile gamers",
    SLC_35: "console & pc gamers",
    SLC_36: "green living enthusiasts",
    SLC_37: "hipsters & trendsetters",
    SLC_38: "home decoristas",
    SLC_39: "investors & entrepreneurs",
    SLC_40: "math & science enthusiasts",
    SLC_41: "men's lifestyle",
    SLC_42: "sharp-dressed men",
    SLC_43: "music fans",
    SLC_44: "concert & festival goers",
    SLC_45: "country music fans",
    SLC_46: "dance & electronic music fans",
    SLC_47: "indie & alternative music fans",
    SLC_48: "pop music fans",
    SLC_49: "punk & metal fans",
    SLC_50: "rock music fans",
    SLC_51: "hip-hop music fans",
    SLC_52: "news watchers",
    SLC_53: "business news watchers",
    SLC_54: "celebrity news watchers",
    SLC_55: "political news watchers",
    SLC_56: "outdoor & nature enthusiasts",
    SLC_57: "parents & family-focused",
    SLC_58: "pet & animal lovers",
    SLC_59: "philanthropists",
    SLC_60: "photographers",
    SLC_61: "shoppers",
    SLC_62: "big box shoppers",
    SLC_63: "department store shoppers",
    SLC_64: "luxury shoppers",
    SLC_65: "online shoppers",
    SLC_66: "toy shoppers",
    SLC_67: "sports fans",
    SLC_68: "college basketball fans",
    SLC_69: "american football fans",
    SLC_70: "baseball fans",
    SLC_71: "basketball fans",
    SLC_72: "college football fans",
    SLC_73: "fight & wrestling fans",
    SLC_74: "golfers",
    SLC_75: "hockey fans",
    SLC_76: "motor sports fans",
    SLC_77: "olympics enthusiasts",
    SLC_78: "snow sport enthusiasts",
    SLC_79: "soccer enthusiasts",
    SLC_80: "street sport enthusiasts",
    SLC_81: "tennis & racquet enthusiasts",
    SLC_82: "water sport enthusiasts",
    SLC_83: "techies & gadget fans",
    SLC_84: "travel enthusiasts",
    SLC_86: "family travelers",
    SLC_87: "frequent travelers",
    SLC_88: "women's lifestyle",
    SLC_89: "automotive shoppers",
    SLC_90: "high schoolers",
    SLC_91: "wellness & healthy lifestyle",
    SLC_94: "latin music fans",
    SLC_95: "soul & r&b fans",
    SLC_96: "world music fans",
    SLC_97: "cricket fans",
    SLC_98: "crime & mystery genre fans",
    SLC_99: "indie & foreign film fans",
    SLC_100: "talent & competition show fans",
    SLC_101: "talk show fans",
    SLC_102: "teen & young adult genre fans",
    SLC_103: "burger lovers",
    SLC_104: "coffee lovers",
    SLC_105: "pizza lovers",
    SLC_106: "shopping mall shoppers",
    SLC_107: "casino visitors",
    SLC_108: "theme park visitors",
    SLC_109: "sneakerheads",
    SLC_110: "energy drink consumers",
    SLC_111: "soft drink consumers",
    SLC_113: "social drinkers",
    SLC_114: "beer drinkers",
    SLC_115: "wine enthusiasts",
    SLC_116: "liquor & spirits drinkers",
    SLC_121: "fun trivia & quiz fanatics",
    SLC_122: "meme watchers",
    SLC_123: "chat fiction enthusiasts",
    SLC_124: "advocates & activists",
    SLC_126: "new phone seekers",
    SLC_150: "esports enthusiasts",
};
